import { GridItem, Text } from "@certn/cascadia-react";
import { RenderContext } from "@certn/cascadia-react/context/RenderContext";
import { css } from "@emotion/css";
import { t } from "i18next";
import { useContext } from "react";

import { InvoiceStatus } from "../../../../src/schemas-and-types";

interface Props {
  stripePaymentLink: string;
  status: InvoiceStatus;
  number: number;
}

export function PayNowLink(props: Props) {
  const status = props.status;
  const number = props.number;
  const stripePaymentLink = props.stripePaymentLink;
  const isPDF = useContext(RenderContext).isForPdfGeneration;
  const showPayNowLink = isPDF && status === "OPEN";
  return (
    <>
      <GridItem span={number} className={styles.noBreak}>
        <Text style="global/heading-medium">{t("Credit Card Payment")}</Text>
        {showPayNowLink && (
          <Text style="global/footer-small">
            <a href={stripePaymentLink}>{t("Pay Now")}</a>
          </Text>
        )}
      </GridItem>
    </>
  );
}

const styles = {
  noBreak: css({
    pageBreakInside: "avoid",
  }),
};
